<template>
  <div class="chart-error">
    <NoDataIcon class="error-icon" />
    <div class="error-text">No data to display</div>
  </div>
</template>

<script lang="ts" setup>
import NoDataIcon from '@/shared/icons/InsertChartOutlined.vue';
</script>

<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;
</style>
